import { useMemo } from 'react';
import { TicketsPage } from '@/components/tickets/TicketsPage';
import { makeTicketApi } from '@/shared/api/ticketApi';

// Super-admin: KaliAI support inbox — sees ONLY platform tickets across all
// tenants, can change status/priority/assign. Never sees tenants' internal tickets.
export function Tickets() {
  const api = useMemo(() => makeTicketApi('super'), []);
  return <TicketsPage api={api} title="פניות תמיכה" canManage />;
}
